import styled from 'styled-components'

export const DetailsContent = styled.div`
  display: grid;
  grid-template-rows: auto 1fr;
  grid-row-gap: 30px;
  padding: 15px;
  box-sizing: border-box;
  h2 {
    font-size: 20px;
    font-family: ${props => props.theme.font.family.bold};
    color: black;
  }
  @media screen and (min-width: 1100px) {
    padding: 0px;
  }

`

export const DetailsInfo = styled.div`
  display: grid;
  grid-column-gap: 30px;
  
  @media screen and (min-width: 1100px) {
    ${props => props.fullWidth ? 'width: 100%;' : 'grid-template-columns: 1fr 1fr;'}
  }

`

export const DetailsImg = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  ${props => props.fullWidth ? 'width: 100%;' : ''}
  img {
    width: 100%;
    max-height: 600px;
    object-fit: contain;
  }
  @media screen and (min-width: 1100px) {
    img {
      width: 552px;
    }
  }

`

export const DetailsInfoText = styled.div`
  h3 {
    font-size: 20px;
    font-family: ${props => props.theme.font.family.medium};
    color: ${props => props.theme.color.black2};
    margin-bottom: 16px;
  }

  p {
    font-size: 13px;
    line-height:18px;
    color: ${props => props.theme.color.black};
  }
  
  .product-specs__table{
    max-width: calc(100vw - 10px);
    @supports not (aspect-ratio: auto) {
      @media screen and  (max-width:768px){
        max-width: 370px;
      }

    }
  }
 
  @media screen and (min-width: 1100px) {

  }

`
